<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="flex flex-col lg:flex-row md:mt-32 mt-24 gap-8 items-start">
      <!-- Left: Cart Items -->
      <section class="lg:w-2/3 p-6 md:p-8 bg-white border border-gray-200 rounded-2xl h-fit">
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">
          Shopping Cart
        </h2>
        @if (cartItems === null) {
          <div class="col-span-full flex justify-center">
            <app-items-loading />
          </div>
        } @else if (cartItems.length > 0) {
          <div class="flex flex-col gap-1">
            @for (item of cartItems; track $index; let i = $index) {
              <app-cart-item
                [item]="item"
                (increase)="increaseQuantity($event)"
                (decrease)="decreaseQuantity($event)"
                (remove)="removeFromCart($event)"
                class="mb-4"
              ></app-cart-item>
            }
          </div>
        } @else {
          <div class="text-center py-12 text-gray-500">
            <app-items-not-found
              title="Cart is empty!"
              description="You haven't added any products yet."
              [icon]="faCartPlus"
            ></app-items-not-found>
          </div>
        }
      </section>

      <!-- Right: Address + Payment Summary -->
      <aside class="lg:w-1/3 p-6 md:p-8 rounded-2xl bg-white border border-gray-200 h-fit">
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">Checkout</h2>

        <!-- Address Form -->
        <form class="space-y-5" [formGroup]="checkoutForm">
          <!-- Full Name -->
          <input
            type="text"
            placeholder="Full Name"
            formControlName="fullName"
            class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          />
          <div
            *ngIf="
              checkoutForm.get('fullName')?.invalid &&
              checkoutForm.get('fullName')?.touched
            "
            class="text-red-600 text-sm"
          >
            Full Name is required.
          </div>

          <!-- Address -->
          <input
            type="text"
            placeholder="Address"
            formControlName="address"
            class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          />
          <div
            *ngIf="
              checkoutForm.get('address')?.invalid &&
              checkoutForm.get('address')?.touched
            "
            class="text-red-600 text-sm"
          >
            Address is required.
          </div>

          <!-- Country (Dropdown) -->
          <select
            formControlName="country"
            class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          >
            <option value="" disabled>Select Country</option>
            <option *ngFor="let country of countries" [value]="country">
              {{ country }}
            </option>
          </select>
          <div
            *ngIf="
              checkoutForm.get('country')?.invalid &&
              checkoutForm.get('country')?.touched
            "
            class="text-red-600 text-sm"
          >
            Country is required.
          </div>

          <!-- Province (Dropdown) -->
          <select
            formControlName="province"
            class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          >
            <option value="" disabled>Select Province</option>
            <option *ngFor="let province of provinces" [value]="province">
              {{ province }}
            </option>
          </select>
          <div
            *ngIf="
              checkoutForm.get('province')?.invalid &&
              checkoutForm.get('province')?.touched
            "
            class="text-red-600 text-sm"
          >
            Province is required.
          </div>

          <!-- City (Dropdown – depends on Province) -->
          <select
            formControlName="city"
            class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          >
            <option value="" disabled>Select City</option>
            <option *ngFor="let city of availableCities" [value]="city">
              {{ city }}
            </option>
          </select>
          <div
            *ngIf="
              checkoutForm.get('city')?.invalid &&
              checkoutForm.get('city')?.touched
            "
            class="text-red-600 text-sm"
          >
            City is required.
          </div>

          <!-- Postal Code -->
          <input
            type="text"
            placeholder="Postal Code"
            formControlName="postalCode"
            class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          />
          <div
            *ngIf="
              checkoutForm.get('postalCode')?.invalid &&
              checkoutForm.get('postalCode')?.touched
            "
            class="text-red-600 text-sm"
          >
            Postal Code is required.
          </div>

          <!-- Phone -->
          <input
            type="text"
            placeholder="Contact Number"
            formControlName="phone"
            class="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--primary)]"
          />
          <div
            *ngIf="
              checkoutForm.get('phone')?.invalid &&
              checkoutForm.get('phone')?.touched
            "
            class="text-red-600 text-sm"
          >
            Phone Number is required.
          </div>

          <!-- Coupon Section -->
          <div class="border border-gray-300 p-4 rounded-lg mb-4 bg-gray-50">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Coupon Code
            </label>

            <div class="flex gap-2">
              <input
                type="text"
                placeholder="Enter coupon code"
                class="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black"
              />

              <button
                (click)="applyCoupon()"
                class="bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800"
              >
                Apply
              </button>
            </div>

            <p *ngIf="couponMessage" class="text-sm mt-2 text-green-600">
              {{ couponMessage }}
            </p>
          </div>
          <!-- <button
            type="button"
            [disabled]="true"
            [ngClass]="true ? 'bg-gray-500' : 'bg-[var(--primary)]'"
            class="w-full cursor-pointer text-white py-3 rounded-xl hover:opacity-90 transition"
          >
            <fa-icon [icon]="faShoppingCart"></fa-icon>
            Order Via Payhere
          </button> -->
        </form>
        <!-- Payment Summary -->
        <div class="border-t pt-6 mt-5 space-y-4 text-gray-700 text-lg">
          <div class="flex justify-between">
            <span>Subtotal</span>
            <span class="font-medium">
              Rs. {{ subtotal | number: "1.2-2" }}
            </span>
          </div>

          <div class="flex justify-between">
            <span>Shipping</span>
            <span class="font-medium">
              Rs. {{ shipping | number: "1.2-2" }}
            </span>
          </div>

          <div class="flex justify-between">
            <span>Service Charge</span>
            <span class="font-medium">
              Rs. {{ serviceCharge || 0 | number: "1.2-2" }}
            </span>
          </div>

          <div class="flex justify-between text-red-500">
            <span>Discount</span>
            <span class="font-medium">
              - Rs. {{ discount | number: "1.2-2" }}
            </span>
          </div>

          <div
            class="flex justify-between font-bold text-xl text-gray-900 border-t pt-3"
          >
            <span>Total</span>
            <span>
              Rs.
              {{
                subtotal + shipping + (serviceCharge || 0) - discount
                  | number: "1.2-2"
              }}
            </span>
          </div>
        </div>
        <div class="border-t pt-6 mt-6">
          <h3 class="text-lg font-semibold text-gray-900 mb-4">
            Payment Method
          </h3>

          <div class="space-y-3">
            <!-- Bank Transfer -->
            <label
              class="flex gap-2 flex-col border border-gray-300 rounded-xl p-4 cursor-pointer hover:bg-gray-50"
            >
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="Bank"
                    [(ngModel)]="paymentMethod"
                    (ngModelChange)="onPaymentMethodChange($event)"
                    class="w-4 h-4"
                  />
                  <span class="font-medium text-gray-700"
                    >Bank Transfer
                    <span class="text-red-600"
                      >({{
                        paymentMethods["Bank"]?.discountType === "percentage"
                          ? (paymentMethods["Bank"]?.discount || 0
                              | number: "1.2-2") + "%"
                          : "Rs. " +
                            (paymentMethods["Bank"]?.discount | number: "1.2-2")
                      }}
                      Off)</span
                    ></span
                  >
                </div>
                <span class="text-sm text-gray-500"> Manual payment </span>
              </div>
              <div
                class="border border-gray-300 rounded-xl bg-gray-50 text-sm overflow-hidden"
              >
                <!-- Header (Clickable) -->
                <div
                  class="flex justify-between items-center p-4 cursor-pointer"
                  (click)="toggleBankDetails()"
                >
                  <h3 class="font-semibold text-gray-800">
                    Bank Transfer Details & Instructions
                  </h3>

                  <!-- Arrow Icon -->
                  <span
                    [class.rotate-180]="showBankDetails"
                    class="transition-transform duration-300"
                  >
                    ▼
                  </span>
                </div>

                <!-- Expand Content -->
                <div *ngIf="showBankDetails" class="px-4 pb-4 space-y-3">
                  <div class="space-y-1 text-gray-700">
                    <p>
                      <span class="font-medium">Bank:</span> Commercial Bank
                    </p>
                    <p>
                      <span class="font-medium">Account Name:</span> ONE ZERO
                      CODE (PVT)LTD
                    </p>
                    <p>
                      <span class="font-medium">Account Number:</span>
                      1001031482
                    </p>
                    <p>
                      <span class="font-medium">Branch:</span> 162 -
                      THAMBUTTEGAMA
                    </p>
                  </div>

                  <div
                    class="p-3 bg-yellow-50 border border-yellow-200 rounded-lg"
                  >
                    <p class="font-medium text-gray-800">Instructions</p>
                    <p class="text-gray-600 mt-1">
                      After placing the order using
                      <span class="font-medium">Bank Transfer</span>, please
                      complete the payment and send the payment slip to our
                      <span class="font-medium">WhatsApp</span>. Your order will
                      be confirmed once verified.
                      <br />
                      <span class="font-medium">WhatsApp: </span>
                      <a
                        class="text-green-600 font-medium underline"
                        href="https://wa.me/94788670865"
                        target="_blank"
                        >+94 78 867 0865</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </label>

            <!-- KOKO -->
            <label
              class="flex gap-2 hidden flex-col border border-gray-300 rounded-xl p-4 cursor-pointer hover:bg-gray-50"
            >
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <input
                    type="radio"
                    name="paymentMethod"
                    disabled
                    value="Koko"
                    [(ngModel)]="paymentMethod"
                    (ngModelChange)="onPaymentMethodChange($event)"
                    class="w-4 h-4"
                  />
                  <span class="font-medium text-gray-700">KOKO Pay</span>
                </div>

                <span class="text-sm text-gray-500">Pay in 3 installments</span>
              </div>
              <div class="flex items-center justify-between">
                <a
                  ><img
                    src="https://paykoko.com/img/logo1.7ff549c0.png"
                    alt="KOKO Pay"
                    class="h-7"
                /></a>
                <span
                  >3 x Rs.
                  {{
                    (subtotal +
                      shipping +
                      (paymentMethods["Payhere"]?.serviceChargeType ||
                      ("percentage" === "percentage" &&
                        paymentMethods["Payhere"]?.serviceCharge) ||
                      0
                        ? (subtotal *
                            paymentMethods["Payhere"]!.serviceCharge || 0) / 100
                        : paymentMethods["Payhere"]?.serviceCharge || 0)) /
                      3 | number: "1.2-2"
                  }}</span
                >
              </div>
            </label>

            <!-- PayHere -->
            <label
              class="flex gap-2 hidden flex-col border border-gray-300 rounded-xl p-4 cursor-pointer hover:bg-gray-50"
            >
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <input
                    type="radio"
                    disabled
                    name="paymentMethod"
                    value="Payhere"
                    (ngModelChange)="onPaymentMethodChange($event)"
                    [(ngModel)]="paymentMethod"
                    class="w-4 h-4"
                  />
                  <span class="font-medium text-gray-700">PayHere</span>
                </div>
                <span class="text-sm text-gray-500"> Credit / Debit Card </span>
              </div>

              <a
                ><img
                  src="https://www.payhere.lk/downloads/images/payhere_short_banner.png"
                  alt="PayHere"
                  width="100%"
              /></a>
            </label>
          </div>
        </div>

        <!-- Terms & Conditions -->
        <div class="flex items-start gap-2 my-5">
          <input
            type="checkbox"
            [(ngModel)]="termsAccepted"
            class="custom-check"
          />
          <label class="text-sm text-gray-600">
            I agree to the
            <a
              routerLink="/terms-and-conditions"
              class="text-[var(--primary)] underline"
            >
              Terms & Conditions
            </a>
          </label>
        </div>

        <!-- Buttons -->
        <button
          type="button"
          (click)="payNow()"
          [ngClass]="
            cartItems?.length === 0 ||
            checkoutForm.invalid ||
            loadingWhatsApp ||
            !termsAccepted
              ? 'bg-gray-500'
              : 'bg-green-500'
          "
          [disabled]="
            cartItems?.length === 0 ||
            checkoutForm.invalid ||
            loadingWhatsApp ||
            !termsAccepted
          "
          class="w-full cursor-pointer font-semibold flex gap-1 justify-center text-white py-4 rounded-xl hover:opacity-90 transition mt-3"
        >
          @if (loadingWhatsApp) {
            <app-loading-button />
          } @else {
            <fa-icon [icon]="faCreditCard" size="lg"></fa-icon>
          }
          Pay Now
        </button>
      </aside>
    </div>
  </div>
</div>
